<div class="container-fluid">
  <div class="row mb-4">
    <div class="fw-bold fs-27 col-md-6 col-12 mt-2">
      Students List
      <div class="border-green-bottom"></div>
    </div>
    <div class="col-md-6 col-12 mt-2 d-flex justify-content-md-end">
      <div class="search-area">
        <div [innerHtml]="SVG_ICONS.SEARCH_ICON() | sanitizer : 'html'" class="position-absolute mt-2 ms-2"></div>
        <input type="text" class="search-input" placeholder="Search Student" (keyup)="applyFilter($event)" />
      </div>
    </div>
  </div>

  <!-- <div class="d-flex justify-content-end mb-4">
    <button class="btn btn-primary" routerLink="/trainer-contract">Commission Report</button>
  </div> -->
  <div class="table-responsive-scroll">
    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" class="w-100" matSort>
        <ng-container matColumnDef="FirstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Student Name</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">
            <div class="d-flex align-items-center gap-2">
              <img [src]="item?.ProfileDocuments?.length ? item.ProfileDocuments[0].URL : 'public/no-image.jpg'" width="50" height="50" class="rounded-circle" alt="profile" />
              <div class="d-flex flex-column">
                <span class="fw-bold font-white">{{ item.FirstName || "-" }} {{ item.MiddleName || "" }} {{ item.LastName || "" }}</span>
                <span class="fs-12 font-white">
                  <a href="tel: +91 {{ item.MobileNo || '-' }}" class="font-white fs-12 fw-normal text-decoration-none">+91 {{ item.MobileNo }}</a>
                </span>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="TxnID">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">TxnID</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.PaymentReceipts?.[0]?.TranscationNo || "-" }}</td>
        </ng-container> -->

        <ng-container matColumnDef="PackageName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Membership</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">
            {{
            item.packageSubscriptions?.[0]?.packageDetails?.PackageName || "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="ClassName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Class</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ getActiveClassNames(item) }}</td>
        </ng-container>

        <ng-container matColumnDef="CenterName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Center</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">
            <div class="fw-bold d-flex justify-content-center border-radius-10 fs-14 font-white bg-card-secondary p-2">{{ item.center?.CenterName || "-" }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="Date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Payment Date</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">
            {{ (item.packageSubscriptions?.[0]?.CreatedDate |
            date : "dd/MM/yyyy") || "-" }}
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="Mode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Mode</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ getActiveClassStatus(item.Student) === "Pending" ? "-" : "Cash" }}</td>
        </ng-container> -->

        <ng-container matColumnDef="FinalAmount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Amount</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">
            {{ item.packageSubscriptions?.[0]?.packageDetails?.FinalAmount|| '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Status</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">
            <div
              class="d-flex align-items-center justify-content-center"
              [ngClass]="{
                'paid-btn px-2': getActiveClassStatus(item) === 'Paid',
                'pending-btn px-2': getActiveClassStatus(item) === 'Pending'
              }">
              <div class="py-1">{{ getActiveClassStatus(item) }}</div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="Receipt">
          <th mat-header-cell *matHeaderCellDef class="font-gray">Receipt</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">
            <ng-container *ngIf="getActiveClassStatus(item) as status">
              <button
                [matTooltip]="status === 'Pending' ? 'Receipt will be available once payment is done' : 'Download the payment receipt'"
                matTooltipPosition="above"
                class="download-btn-minimal font-white cursor-pointer fs-14 border-radius-10 fw-medium d-inline-flex align-items-center gap-2 bg-none py-1 px-2"
                [class.disabled]="status !== 'Paid'"
                [disabled]="status !== 'Paid'"
                (click)="downloadReceipt(item)">
                <div [innerHTML]="SVG_ICONS.DOWNLOAD_ICON() | sanitizer : 'html'"></div>
                Receipt
              </button>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 20, 200]" [length]="length" showFirstLastButtons class="mt-3"></mat-paginator>
    </div>
  </div>
</div>

@if(dataSource.data.length === 0){
<div class="text-center font-red-light fs-20 mt-4">No Data Found</div>
}
